import { RefreshIcon } from "@/assets/icons";
import { Button } from "@/components/ui/button";

const TEST_ID_PREFIX = "form-footer-actions";

type FormFooterActionsProps = {
  primaryLabel?: string;
  onPrimaryButtonClicked?: () => void;
  primaryDisabled?: boolean;
  primaryType?: "submit" | "button";
  isSubmitting?: boolean;
  secondaryLabel?: string;
  onSecondaryButtonClicked?: () => void;
  secondaryType?: "submit" | "button";
  testId?: string;
};

const FormFooterActions = ({
  primaryLabel = "Primary Action",
  onPrimaryButtonClicked,
  primaryDisabled = false,
  primaryType = "submit",
  isSubmitting = false,
  secondaryLabel = "Secondary Action",
  onSecondaryButtonClicked,
  secondaryType = "button",
  testId = TEST_ID_PREFIX
}: FormFooterActionsProps) => (
  <div
    className="flex px-6 pb-6 pt-4 gap-3 justify-between"
    style={{
      boxShadow: "0px -4px 4px 0px rgba(0, 0, 0, 0.05)"
    }}
  >
    <Button
      type={secondaryType}
      variant="outline"
      className="w-full rounded-xl text-base font-semibold py-3"
      size="lg"
      disabled={isSubmitting}
      onClick={onSecondaryButtonClicked}
      data-testid={`${testId}-${secondaryLabel}-button`}
    >
      {secondaryLabel}
    </Button>
    <Button
      type={primaryType}
      className="w-full rounded-xl text-base font-semibold py-3"
      size="lg"
      onClick={onPrimaryButtonClicked}
      disabled={primaryDisabled || isSubmitting}
      data-testid={`${testId}-${primaryLabel}-button`}
    >
      <span>
        {isSubmitting ? (
          <RefreshIcon className="fill-white w-5 animate-spin duration-1000 h-5" />
        ) : (
          primaryLabel
        )}
      </span>
    </Button>
  </div>
);

export default FormFooterActions;
